var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bsp-header"},[_c('h1',[_vm._v("Bao Sparring Partner (Beta)")]),_c('p',{staticClass:"subtitle"},[_vm._v("Practice your sales calls with an AI sparring partner")])])
}]

export { render, staticRenderFns }